import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    limit: 20,
    page: 1,
    total: 0,
    totalPages: 1,
};

export const giftCardPageSlice = createSlice({
    name: "giftCardPageSlice",
    initialState,
    reducers: {
        setGiftCardPageLimit: (state, action) => {
            state.limit = action.payload;
        },
        setGiftCardCurrentPage: (state, action) => {
            state.page = action.payload;
        },
        setGiftCardTotalCount: (state, action) => {
            state.total = action.payload;
        },
        setGiftCardTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        resetGiftPagination: (state, action) => {
            state.limit = 20;
            state.page = 1;
            state.total = 0;
            state.totalPages = 1;
        },
    },
});

export const {
    setGiftCardPageLimit,
    setGiftCardCurrentPage,
    setGiftCardTotalCount,
    setGiftCardTotalPages,
    resetGiftPagination,
} = giftCardPageSlice.actions;

export default giftCardPageSlice.reducer;